module.exports = __webpack_public_path__ + "OpenSans-Bold-3326e4d74d3924ee1c882c29f5b571c0.woff2";